import { takeLatest } from 'redux-saga/effects';
import sagaActions from '../../actions/index';
import { getScanRateLimitSaga, postScanRateLimitSaga } from './scanRateLimitSaga';

export function* scanRateLimitSaga() {
  yield takeLatest(sagaActions.GET_SCAN_RATE_LIMIT, getScanRateLimitSaga);
  yield takeLatest(sagaActions.POST_SCAN_RATE_LIMIT, postScanRateLimitSaga);
}
